import { track_ga } from '@/pages/firebase'

// 点击分享后，媒体选择按钮的曝光
export const share_show = ({ page }) => {
  track_ga('share_show', {
    page,
  })
}
